export default {
  'sendticket.sendticket': 'Ticket senden',
  'sendticket.sentsuccessfully': 'Ticket wird erfolgreich gesendet',
  'sendticket.replytickets': 'Rückantwort Ticket',
  'sendticket.you': 'Sie',
  'sendticket.operator': 'Operator',
  'sendticket.reply': 'Rückantwort',
  'sendticket.createdat': 'Hergestellt in',
  'sendticket.laststatus': 'Letzter Status',
  'sendticket.ticketid': 'Ticketnummer',
  'sendticket.closeticketquestion': 'Hat Ihr Ticket erfolgreich beantwortet?',
  'sendticket.closeticket': 'Ja, dieses Ticket schließen',
  'sendticket.notcloseticket': 'Nein',
  'sendticket.closedsuccessfully': 'Ticket erfolgreich geschlossen',
  'sendticket.downloadfile': 'Datei herunterladen',
  'sendticket.daysago': 'Vor Tagen',
  'sendticket.hoursago': 'Vor Stunden',
  'sendticket.minutesago': 'Vor ein paar Minuten',
  'sendticket.yes': 'ja, wurde beantwortet',
  'sendticket.today': '( heute )',
  'sendticket.yesterday': '( gestern )',
  'sendticket.justnow': 'Soeben',
};
